import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import { connect } from 'react-redux';
import './App.css';
import TitleBar from './components/TitleBar';
import WeatherError from './components/WeatherError';
import SearchBar from './containers/SearchBar';
import ClearButton from './containers/ClearButton';
import WeatherList from './containers/WeatherList';

class App extends Component {
	render() {
		const localWeather = JSON.parse(localStorage.getItem('localWeather'));
		return (
			<div className="App">
				<Container>
					<TitleBar />
					<SearchBar />
					{this.props.weatherError && <WeatherError />}
					{localWeather && localWeather.length > 0 && <ClearButton />}
					<WeatherList />
				</Container>
			</div>
		);
	}
}

const mapStateToProps = ({ weather, weatherError }) => ({
	weather,
	weatherError
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js